module.exports = __webpack_public_path__ + "static/img/9areaB_05.721f915.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_05.png
// module id = 1246
// module chunks = 1